//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pick from 'lodash.pick';
import { filterObj } from '@/utils/util';
import DictItemModal from "./modules/DictItemModal";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: 'DictItemList',
  mixins: [JeecgListMixin],
  components: {
    DictItemModal: DictItemModal
  },
  data: function data() {
    return {
      columns: [{
        title: '名称',
        align: 'center',
        dataIndex: 'itemText'
      }, {
        title: '数据值',
        align: 'center',
        dataIndex: 'itemValue'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      queryParam: {
        dictId: '',
        dictName: '',
        itemText: '',
        delFlag: '1',
        status: []
      },
      title: '操作',
      visible: false,
      screenWidth: 800,
      model: {},
      dictId: '',
      status: 1,
      labelCol: {
        xs: {
          span: 5
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 12
        },
        sm: {
          span: 12
        }
      },
      form: this.$form.createForm(this),
      validatorRules: {
        itemText: {
          rules: [{
            required: true,
            message: '请输入名称!'
          }]
        },
        itemValue: {
          rules: [{
            required: true,
            message: '请输入数据值!'
          }]
        }
      },
      url: {
        list: '/sys/dictItem/list',
        delete: '/sys/dictItem/delete',
        deleteBatch: '/sys/dictItem/deleteBatch'
      }
    };
  },
  created: function created() {
    // 当页面初始化时,根据屏幕大小来给抽屉设置宽度
    this.resetScreenSize();
  },
  methods: {
    add: function add(dictId) {
      this.dictId = dictId;
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      if (record.id) {
        this.dictId = record.id;
      }

      this.queryParam = {};
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.model.dictId = this.dictId;
      this.model.status = this.status;
      this.visible = true;
      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'itemText', 'itemValue'));
      }); // 当其它模块调用该模块时,调用此方法加载字典数据

      this.loadData();
    },
    getQueryParams: function getQueryParams() {
      var param = Object.assign({}, this.queryParam);
      param.dictId = this.dictId;
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    // 添加字典数据
    handleAdd: function handleAdd() {
      this.$refs.modalForm.add(this.dictId);
      this.$refs.modalForm.title = '新增';
    },
    showDrawer: function showDrawer() {
      this.visible = true;
    },
    onClose: function onClose() {
      this.visible = false;
      this.form.resetFields();
      this.dataSource = [];
    },
    // 抽屉的宽度随着屏幕大小来改变
    resetScreenSize: function resetScreenSize() {
      var screenWidth = document.body.clientWidth;

      if (screenWidth < 600) {
        this.screenWidth = screenWidth;
      } else {
        this.screenWidth = 600;
      }
    }
  }
};